module.exports = __webpack_public_path__ + "media/images/area/feature/prefecture/gunma_excellence/map-en-e7563522f9c1931276ed846d4ed3665e.png";